import React from 'react';
import { useFela } from 'react-fela';

const rules = ({ theme }) => ({
  position: 'absolute',
  bottom: '10px',
  left: '3%',
  width: '94%',
  height: '6px',
  background: theme.color.playerProgressTrack,
  ':hover .miniThumb': {
    background: theme.color.light,
    height: '14px',
    width: '14px',
  },
});

const TrackMini = React.forwardRef((props, ref) => {
  const { css } = useFela();

  return (
    <div
      ref={ref}
      className={css(rules)}
      {...props}
    />
  );
});
TrackMini.displayName = 'TrackMini';

export default React.memo(TrackMini);
